import { Component } from '@angular/core';
import { Extrainfo } from 'src/app/models/form/book-data';
import { FormDataService } from 'src/app/services/form-data.service';

@Component({
  selector: 'app-swedbank-other-details',
  templateUrl: './swedbank-other-details.component.html',
  styleUrls: ['./swedbank-other-details.component.scss']
})
export class SwedbankOtherDetailsComponent {

  extrainfo:Extrainfo;


  
constructor (
  private formDataService : FormDataService ,  
  public formData : FormDataService
  ) 
  {

  this.extrainfo = formDataService.extrainfo;

}

}
